import { IMG } from "../../lib/assets";

export const Narrative = () => {
  return (
    <section
      id="narrative"
      className="relative py-28 md:py-40 overflow-hidden scroll-mt-20"
      data-testid="narrative-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-7 lg:pt-8">
            <p className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.2] text-[#3B2630] tracking-tight">
              Somewhere between the idea and the action, something talks you
              out of a loop you can&rsquo;t quite name&hellip;
            </p>

            <div className="warm-divider-h my-10 max-w-md" />

            <div className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed space-y-5 max-w-2xl">
              <p>
                Or a pattern you keep circling back to without realising
                you&rsquo;re circling. Or knowing you&rsquo;re circling, but
                you can&rsquo;t seem to get yourself out of the old pattern.
              </p>
              <p className="font-serif italic text-2xl md:text-3xl text-[#C9587E] !mt-10 leading-snug">
                That&rsquo;s what I&rsquo;m listening for.
              </p>
              <p className="!mt-10">I&rsquo;m J.</p>
              <p>
                I&rsquo;m a master hypnotherapist and certified therapist, and
                when you send me a voice note I&rsquo;m not just hearing your
                words&hellip; I&rsquo;m tracking the frequency of your voice.
              </p>
              <p>
                I&rsquo;m listening for the classic truths you say that you
                might not even be aware of, and I&rsquo;m cleaning up the
                cobwebs that keep getting in the way.
              </p>
              <p className="font-serif italic text-2xl md:text-3xl text-[#3B2630] !mt-10 leading-snug">
                I don&rsquo;t call you out. I call you up.
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="relative aspect-[3/4] overflow-hidden rounded-2xl shadow-ambient">
              <img
                src={IMG.meditation}
                alt="J in meditation"
                className="img-warm w-full h-full object-cover"
                data-testid="narrative-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
